document.addEventListener("DOMContentLoaded", function () {
  var richText = document.querySelector(".rich-text__inner");
  if (!richText) return;

  if (richText.scrollHeight <= 280) return;
  if (document.querySelector(".collection-readmore-btn")) return;

  var wrapper = document.createElement("div");
  wrapper.className = "collection-readmore-wrapper";

  var button = document.createElement("button");
  button.type = "button";
  button.className = "collection-readmore-btn";
  button.textContent = "Devamını Oku";

  button.addEventListener("click", function () {
    richText.classList.toggle("is-expanded");

    if (richText.classList.contains("is-expanded")) {
      button.textContent = "Daha Az Göster";
    } else {
      button.textContent = "Devamını Oku";
      richText.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  });

  wrapper.appendChild(button);
  richText.insertAdjacentElement("afterend", wrapper);
});